import {
  HardDrive,
  ArrowLeft,
  Folder,
  FileText,
  Image,
  Film,
} from "lucide-react";
import { Link } from "react-router-dom";
import styles from "./Storage.module.css";

const Storage = () => {
  const totalStorage = 100;
  const usedStorage = 45.8;
  const usedPercentage = (usedStorage / totalStorage) * 100;

  const storageBreakdown = [
    { type: "CAD Files", size: 32.4, color: "#3b82f6", icon: FileText },
    // { type: "Images", size: 8.2, color: "#10b981", icon: Image },
    // { type: "Videos", size: 3.7, color: "#f59e0b", icon: Film },
    { type: "Other", size: 1.5, color: "#64748b", icon: Folder },
  ];

  const formatSize = (gb) => {
    return `${gb.toFixed(1)} GB`;
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Link to="/file-manager" className={styles.backButton}>
          <ArrowLeft size={20} />
          Back to File Manager
        </Link>
        <h1 className={styles.title}>Storage Management</h1>
      </div>

      <div className={styles.content}>
        <div className={styles.storageOverview}>
          <div className={styles.storageIcon}>
            <HardDrive size={48} />
          </div>
          <div className={styles.storageStats}>
            <h2 className={styles.storageUsed}>
              {formatSize(usedStorage)}{" "}
              <span>of {formatSize(totalStorage)}</span>
            </h2>
            <div className={styles.progressBar}>
              <div
                className={styles.progressFill}
                style={{ width: `${usedPercentage}%` }}
              />
            </div>
            <p className={styles.storageText}>
              {(totalStorage - usedStorage).toFixed(1)} GB available
            </p>
          </div>
        </div>

        <div className={styles.breakdown}>
          <h3 className={styles.breakdownTitle}>Storage Breakdown</h3>
          <div className={styles.breakdownList}>
            {storageBreakdown.map((item) => {
              const Icon = item.icon;
              const percentage = (item.size / usedStorage) * 100;

              return (
                <div key={item.type} className={styles.breakdownItem}>
                  <div className={styles.breakdownInfo}>
                    <div
                      className={styles.breakdownIcon}
                      style={{ backgroundColor: item.color }}
                    >
                      <Icon size={20} />
                    </div>
                    <div className={styles.breakdownDetails}>
                      <span className={styles.breakdownType}>{item.type}</span>
                      <span className={styles.breakdownSize}>
                        {formatSize(item.size)}
                      </span>
                    </div>
                  </div>
                  <div className={styles.breakdownBar}>
                    <div
                      className={styles.breakdownBarFill}
                      style={{
                        width: `${percentage}%`,
                        backgroundColor: item.color,
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.planSection}>
          <div className={styles.planCard}>
            <h3 className={styles.planTitle}>Current Plan</h3>
            <p className={styles.planName}>Professional</p>
            <p className={styles.planDescription}>
              100 GB storage with unlimited file uploads
            </p>
            <button className={styles.upgradeButton}>Upgrade Plan</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Storage;
